const CopyUrlToClipboard = {
  mounted() {
    this.handleClick = async (e) => {
      const baseUrl = window.location.origin;
      const url = this.el.dataset.target;
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(`${baseUrl}${url}`);
        } catch (err) {
          await this.fallbackCopy(`${baseUrl}${url}`);
        }
      } else {
        await this.fallbackCopy(`${baseUrl}${url}`);
      }
    };
    this.el.addEventListener("click", this.handleClick);
  },

  async fallbackCopy(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy URL: ", err);
    }
    document.body.removeChild(textArea);
  },

  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  }
};

export default CopyUrlToClipboard;
